import { useEffect, useRef, useState } from "react";
import { getActiveLanguage } from "react-localize-redux";
import { useSelector } from "react-redux";

import { getUser } from "@utils";

const selectLanguage = (state) => ({
	currentLanguage: getActiveLanguage(state.localize).code,
});

const useController = () => {
	const containerRef = useRef(null);
	const observerRef = useRef(
		new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						setIntersected(true);
					}
				});
			},
			{ threshold: 0.5 }
		)
	);

	const userData = getUser();

	const { currentLanguage } = useSelector(selectLanguage);
	const [intersected, setIntersected] = useState(false);
	const [windowWidth, setWindowWidth] = useState(window.innerWidth);

	const getSlidesPerGroup = (width) => {
		if (width <= 425) return 1;
		if (width <= 768) return 2;
		if (width < 1440) return 3;
		if (width < 1600) return 4;
		return 6;
	};

	useEffect(() => {
		const handleResize = () => {
			setWindowWidth(window.innerWidth);
		};

		window.addEventListener("resize", handleResize);

		return () => {
			window.removeEventListener("resize", handleResize);
		};
	}, []);

	useEffect(() => {
		if (containerRef.current) {
			observerRef.current.observe(containerRef.current);
		}
	}, [containerRef.current]);

	return {
		refs: { containerRef },
		helpers: { getSlidesPerGroup },
		state: { intersected, windowWidth, currentLanguage: currentLanguage || "en", userData },
	};
};

export default useController;
